import React, { useContext } from "react";
import { Router, Location } from "@reach/router";

import UserProvider from "../providers/UserProvider";

import Navigation from "./Navigation";

import TutorialsPage from "./TutorialsPage";
import AddTutorial from "./AddTutorial";
import Login from "./Login";


import { UserContext } from "../providers/UserProvider";
// import PasswordReset from "./PasswordReset";



function Application() {

  const user = useContext(UserContext);

  return (
    <div>
      <Navigation />

      {!user ? (
        <Location>
          {({ location }) => {
            // return <p>Current Location: {location.pathname}</p>;
            if(location.pathname === '/'){
              return(
                <Login />
              );

            }
          }}
        </Location>

      ) : (

        <Router>
          <TutorialsPage default />
          <AddTutorial path="addtutorial"/>
        </Router>

      )}
    </div>
  )

}

export default Application;
